import { LoaderContainer } from "./styles";

const Loader = () => {
    return (
        <LoaderContainer >
            <div className="spinner">
                <div className="double-bounce1"></div>
                <div className="double-bounce2"></div>
            </div>
        </LoaderContainer>
    )
}

export default Loader;